import { generateMedia } from 'styled-media-query';
generateMedia({
  xs: '350px',
});

const SETTING = {
  maxWidth: 768,
  baseWidth: 375,
};

const COLOR = {
  PRIMARY: '#2A7589',
  SECONDORY: '#C23F32',
  BTN_DISABLED: '#919191',
  ECRU: '#EEEEE3',
  TEXT_COLOR: '#1A1A1A',
  TEXTBOX_BORDER: '#EEEEE3',
  TEXT_GRAY: '#919191',
  BAR_GRAY: '#E0E1E3',
  BG_GRAY: '#F6F7F9',
  INPUT_BORDER: '#D2D2D2',
  WHITE: '#FFFFFF',
  RED: '#C23F32',
  GREEN: '#279A40',
  GREEN_LIGHT: '#EAF9ED',
};

const COLORS = {
  BLACK: '#1A1A1A',
  GRAY6: '#A1A1A4',
  LINK_BLUE: '#007AFF',
};

const TYPO = {
  LV1: '22px',
  LV2: '20px',
  LV3: '18px',
  TEXT: '14px',
  SMLTEXT: '12px',
};

const MEDIAQUERY = generateMedia({
  huge: '1440px',
  large: '1170px',
  medium: '768px',
  small: '450px',
  xs: '350px',
});

// const percentage = (num:number) => {
//   const p = num / SETTING.baseWidth
//   return floatFormat(p, 2) * 100
// }

const createMarginHelper = () => {
  let obj: any = {};
  let n = 0;
  const max = 120;
  while (n < max) {
    n = n + 4;
    // obj[`M${n}`] = `${percentage(n)}%`;
    obj[`M${n}`] = `${n}px`;
  }
  return obj;
};

const m = createMarginHelper();

const HELPER = {
  ...m,
};

const StyleConfig = {
  COLOR,
  COLORS,
  TYPO,
  SETTING,
  HELPER,
  MEDIAQUERY,
};

export default StyleConfig;
